import NewTrailCard from '@alltrails/shared/components/TrailCard';
import CustomProvider from 'components/CustomProvider';
import { Context } from '@alltrails/shared/types/context';
import { Trail } from 'types/Trails';
import useAdminFooterCTAs, { ButtonConfig } from 'hooks/useAdminFooterCTAs';
import useLanguageRegionCode from 'hooks/useLanguageRegionCode';
import useActivityDuration from 'hooks/useActivityDuration';
import { getTrailForTrailCard } from 'utils/cardInfo';

type TrailHoverCardProps = {
  allowClickingCompletedBadge?: boolean;
  bottomButtonsConfig?: ButtonConfig[];
  context: Context;
  handleCardClick: () => void;
  handleCompletedBadgeClick?: () => void;
  handleFavoriteClick: () => void;
  handleMouseEnter?: () => void;
  handleMouseLeave?: () => void;
  isCompleted?: boolean;
  isFavorite?: boolean;
  isVerified?: boolean;
  trail: Trail;
  trailUrl?: string;
};

export default function TrailHoverCard({
  allowClickingCompletedBadge,
  bottomButtonsConfig,
  context,
  handleCardClick,
  handleCompletedBadgeClick,
  handleFavoriteClick,
  handleMouseEnter,
  handleMouseLeave,
  isCompleted,
  isFavorite,
  isVerified,
  trail,
  trailUrl
}: TrailHoverCardProps) {
  const languageRegionCode = useLanguageRegionCode();
  const minutes = useActivityDuration(trail);
  const footerCTAs = useAdminFooterCTAs(bottomButtonsConfig);

  // TODO: TD-350 Remove CustomProvider
  return (
    <CustomProvider>
      <NewTrailCard
        languageRegionCode={languageRegionCode}
        onCardClick={handleCardClick}
        onCardMouseEnter={handleMouseEnter}
        onCardMouseLeave={handleMouseLeave}
        onFavoriteClick={handleFavoriteClick}
        isFavorite={isFavorite}
        variant="small"
        trail={getTrailForTrailCard(trail, minutes)}
        useMetric={context?.displayMetric}
        footerCTAs={footerCTAs && footerCTAs.length ? footerCTAs : undefined}
        isCompleted={isCompleted}
        isVerified={isVerified}
        onCompletionBadgeClick={allowClickingCompletedBadge ? handleCompletedBadgeClick : undefined}
        url={trailUrl}
        blockNavigation={!!handleCardClick} // Navigation is handled by the click handler
        openInNewTab
      />
    </CustomProvider>
  );
}
